import { PropertyInputs, LOIInputs, ChartColors, TableColumn, CostReferences } from '../types';
import { APP_CONFIG } from '../config';

export const DEFAULT_INPUTS: PropertyInputs & LOIInputs = {
  propertyName: "Neue Immobilie",
  besichtigung: "",
  stadtgebiet: "Zentrum",
  lage: "B",
  wohnflaeche: APP_CONFIG.PROPERTY.DEFAULT_SIZE,
  zimmer: 3,
  stellplatzTyp: "Nein",
  stellplatzMiete: 50,
  inseratpreis: APP_CONFIG.PROPERTY.DEFAULT_PRICE + 30000,
  angebotspreis: APP_CONFIG.PROPERTY.DEFAULT_PRICE,
  baujahr: 2010,
  gebaudeanteil: 80,
  afaSatz: APP_CONFIG.TAX.DEPRECIATION_RATE * 100,
  steuersatz: APP_CONFIG.TAX.INCOME_TAX_RATE * 100,
  finanzierungsanteil: APP_CONFIG.FINANCE.DEFAULT_FINANCING_PERCENTAGE,
  zinssatz: APP_CONFIG.FINANCE.DEFAULT_INTEREST_RATE,
  zinssatzJ10: 5.0,
  tilgung: APP_CONFIG.FINANCE.DEFAULT_REPAYMENT_RATE,
  makler: 3.57,
  notar: APP_CONFIG.TAX.NOTARY_FEES * 100,
  grundbuchamt: 0.5,
  grunderwerbst: APP_CONFIG.TAX.PROPERTY_TRANSFER_TAX * 100,
  hausgeldUmlagefaehig: 150,
  hausgeldNichtUmlagefaehig: 100,
  istKaltmieteProQm: 10,
  istStellplatzMiete: 0,
  kaltmieteProQm: APP_CONFIG.PROPERTY.DEFAULT_RENT_PER_SQM,
  mietentwicklungProJahr: 2.25,
  inflationProJahr: 2.25,
  wertzuwachsProJahr: 1.5,
  instandhaltung: 10,
  instandhaltungJ10: 15,
  mietausfallrisiko: 2,
  anfangsinvestitionen: 0,
  investitionenJahr10: 0,
  schwierigkeit: 3,
  sofortabschreibungAktivieren: false,
  positiveMerkmale: "",
  negativeMerkmale: "",
  instandhaltungsruecklage: 0,
  verwaltungskosten: 0,
  loiSender: "Ihr Name / Ihre Firma\nIhre Straße 1\n12345 Ihre Stadt\nIhre E-Mail\nIhre Telefonnummer",
  loiRecipient: "Name des Maklers/Eigentümers\nFirma (falls zutreffend)\nStraße 1\n12345 Stadt",
  loiDate: new Date().toISOString().slice(0, 10),
  loiOfferAmount: 0,
  loiIntroduction: "Sehr geehrte/r [Ansprechpartner],\n\nvielen Dank für die Gelegenheit zur Objektprüfung sowie für die Besichtigung am [Datum der Besichtigung].\n\nHiermit bekunde ich meine verbindliche Kaufabsicht und unterbreite Ihnen, basierend auf einer sorgfältigen und sachlichen Bewertung, das nachfolgende Kaufangebot.",
  loiPositiveAspects: "Grundsätzlich sind wir von den Vorzügen Ihrer Immobilie überzeugt. Das vorliegende Kaufangebot beruht maßgeblich auf folgenden positiven Erwägungen:\n\n- Der praktische und gut nutzbare Grundriss der Wohnung, der eine hohe Wohnqualität verspricht und unseren Bedürfnissen als Vermieter langfristig entspricht.\n- Der allgemein gepflegte und instand gehaltene Zustand des Gebäudes, welcher für eine solide Bausubstanz spricht.\n- Die attraktive Makro-Lage der Immobilie.",
  loiPriceReducingAspects: "Im Rahmen unserer Kaufentscheidung müssen jedoch folgende Punkte berücksichtigt werden, die sich aus unserer Sicht preismindernd auswirken:\n\n- Modernisierungsbedarf im Innenbereich: [z.B. Das Badezimmer entspricht nicht mehr dem heutigen Standard und erfordert eine Modernisierung. Auch der vorhandene Bodenbelag ist erneuerungsbedürftig.]\n- Optische Mängel und Instandsetzungsbedarf: [z.B. Die vorhandenen Heizkörper wirken veraltet. Die Balkone zeigen erste Anzeichen von Renovierungsbedarf.]\n- Mängel im Gemeinschaftseigentum/Keller: [z.B. Die Kellertür ist defekt und muss erneuert werden. Der Kellerbereich ist mit Gegenständen belegt, die geräumt werden müssten.]\n- Fehlende Ausstattung: [z.B. Das Fehlen eines Fahrstuhls stellt einen preismindernden Faktor dar.]\n- Allgemeine Marktlage: Die aktuelle Unsicherheit am Zins- und Immobilienmarkt zwingt uns, einen Sicherheitsabschlag in das Angebot einzukalkulieren, um auf wahrscheinliche negative Marktentwicklungen zu reagieren.",
  loiConclusion: "Abschließend möchte ich betonen, dass uns das Gemeinschaftseigentum, die Außenanlage sowie der Standort sehr gut gefallen. Wir freuen uns daher, trotz der vorgenannten Aspekte, auf eine geschäftliche Übereinkunft und eine positive Rückmeldung.\n\nFür Rückfragen stehe ich Ihnen gerne jederzeit zur Verfügung.",
  loiConditions: "Dieses Angebot ist freibleibend, gilt bis zum [Datum eintragen] und steht unter dem Vorbehalt der folgenden Punkte:\n\n- Der finalen und positiven Finanzierungsbestätigung unserer Bank für dieses Objekt.\n- Einer detaillierten Zweitbesichtigung der Wohnung zur umfassenden Prüfung aller relevanter Aspekte (technisch, Zustand etc.), die den finalen Kaufpreis beeinflussen könnten.\n- Der schriftlichen Bestätigung des Verkäufers, dass alle derzeit bekannten oder bereits beschlossenen Maßnahmen (z.B. durch die WEG) und die damit verbundenen Kosten vom aktuellen Eigentümer übernommen werden.",
  // Additional LOI fields
  kauferName: "",
  kauferAdresse: "",
  kauferPLZ: "",
  kauferStadt: "",
  kauferTelefon: "",
  kauferEmail: "",
  verkauferAnrede: "Herr",
  verkauferName: "",
  verkauferAdresse: "",
  verkauferPLZ: "",
  verkauferStadt: "",
  objektbezeichnung: "",
  adresse: "",
  plz: "",
  stadt: "",
  uebergabedatum: "",
  kaufpreisText: "",
  finanzierungsvorbehalt: "",
  zusaetzlicheBedingungen: "",
  notarName: "",
  gueltigkeitTage: 14
};

export const CHART_COLORS: ChartColors = {
  blue: APP_CONFIG.UI.CHART_COLORS.PRIMARY,
  green: APP_CONFIG.UI.CHART_COLORS.SUCCESS,
  purple: APP_CONFIG.UI.CHART_COLORS.INFO,
  orange: APP_CONFIG.UI.CHART_COLORS.WARNING,
  red: APP_CONFIG.UI.CHART_COLORS.DANGER,
  lightBlue: 'rgba(59, 130, 246, 0.2)',
  lightGreen: 'rgba(16, 185, 129, 0.2)',
  lightPurple: 'rgba(139, 92, 246, 0.2)',
  lightOrange: 'rgba(245, 158, 11, 0.2)',
  lightRed: 'rgba(239, 68, 68, 0.2)'
};

export const CHART_COLOR_CYCLE = [
  CHART_COLORS.blue,
  CHART_COLORS.green,
  CHART_COLORS.purple,
  CHART_COLORS.orange,
  CHART_COLORS.red
];

export const CHART_BG_COLOR_CYCLE = [
  CHART_COLORS.lightBlue,
  CHART_COLORS.lightGreen,
  CHART_COLORS.lightPurple,
  CHART_COLORS.lightOrange,
  CHART_COLORS.lightRed
];

export const INPUT_DISPLAY_NAMES: Record<string, string> = {
  propertyName: 'Immobilienname',
  besichtigung: 'Besichtigt',
  stadtgebiet: 'Stadtgebiet',
  lage: 'Lage',
  wohnflaeche: 'Wohnfläche (m²)',
  zimmer: 'Zimmer',
  stellplatzTyp: 'TG/Stellplatz',
  stellplatzMiete: 'SOLL Miete TG/Stellplatz',
  inseratpreis: 'Inseratpreis (€)',
  angebotspreis: 'Angebotspreis (€)',
  baujahr: 'Baujahr',
  gebaudeanteil: 'Gebäude-Anteil (%)',
  afaSatz: 'AfA-Satz (%)',
  steuersatz: 'Steuersatz (%)',
  finanzierungsanteil: 'Finanzierung (%)',
  zinssatz: 'Zinssatz (%)',
  zinssatzJ10: 'Zinsatz J10 (%)',
  tilgung: 'Tilgung (%)',
  makler: 'Makler (%)',
  notar: 'Notar (%)',
  grundbuchamt: 'Grundbuchamt (%)',
  grunderwerbst: 'Grunderwerbst. (%)',
  hausgeldUmlagefaehig: 'Hausgeld Umlagef. (€/Monat)',
  hausgeldNichtUmlagefaehig: 'Hausgeld nicht Umlagef. (€/Monat)',
  istKaltmieteProQm: 'IST-Miete €/m²',
  istStellplatzMiete: 'IST Miete TG/Stellplatz',
  kaltmieteProQm: 'SOLL-Miete €/m²',
  mietentwicklungProJahr: 'Mietentwicklung %/Jahr',
  inflationProJahr: 'Inflation %/Jahr',
  wertzuwachsProJahr: 'Wertzuwachs %/Jahr',
  instandhaltung: 'Instandhaltung (€/m²)',
  instandhaltungJ10: 'Instandhaltung €/m² (ab J11)',
  mietausfallrisiko: 'Mietausfall (%)',
  anfangsinvestitionen: 'Anfängl. Invest. (€)',
  investitionenJahr10: 'Invest. J10 (€)',
  schwierigkeit: 'Schwierigkeit',
  positiveMerkmale: 'Positive Merkmale',
  negativeMerkmale: 'Negative Merkmale'
};

export const KPI_DISPLAY_NAMES: Record<string, string> = {
  kaufpreisIst: 'IST Kaufpreis',
  kaufpreisSoll: 'SOLL Kaufpreis',
  quadratmeterpreisIst: 'IST QM-Preis',
  quadratmeterpreisSoll: 'SOLL QM-Preis',
  bruttomietrenditeIst: 'IST Brutto-Mietrendite',
  bruttomietrenditeSoll: 'SOLL Brutto-Mietrendite',
  eigenkapitalIst: 'IST EK-Bedarf inkl. NK',
  eigenkapitalSoll: 'SOLL EK-Bedarf inkl. NK',
  monatlicheRateIst: 'IST Monatliche Bankrate',
  monatlicheRateSoll: 'SOLL Monatliche Bankrate',
  monatlicheKaltmieteIst: 'IST Monatliche Kaltmiete',
  monatlicheKaltmieteSoll: 'SOLL Monatliche Kaltmiete',
  eigenkapitalrenditeJahr1Ist: 'IST EK-Rendite (Jahr 1)',
  eigenkapitalrenditeJahr1Soll: 'SOLL EK-Rendite (Jahr 1)',
  monatlicherCashflowJahr1IstVorSteuer: 'Monatl. Cashflow (J1) Vor Steuern',
  monatlicherCashflowJahr1IstNachSteuer: 'Monatl. Cashflow (J1) Nach Steuern',
  quadratmeterpreis: 'Quadratmeterpreis',
  bruttomietrendite: 'Brutto-Mietrendite',
  eigenkapital: 'Eigenkapital',
  monatlicheRate: 'Monatliche Rate',
  jaehrlicheAfa: 'Jährl. AfA',
  jahresmiete: 'Jährliche Kaltmieteinnahmen',
  inseratpreisProQm: 'Inseratpreis €/m²',
  angebotspreisProQm: 'Angebotspreis €/m²',
  preisreduktion: 'Preisreduktion (%)'
};

export const TABLE_COLUMN_ORDER: TableColumn[] = [
  { key: 'select', type: 'control', displayName: 'Auswahl' },
  { key: 'favorite', type: 'control', displayName: 'Favorit' },
  { key: 'actions', type: 'control', displayName: 'Aktionen' },
  { key: 'propertyName', type: 'input', displayName: INPUT_DISPLAY_NAMES.propertyName },
  { key: 'besichtigung', type: 'input', displayName: INPUT_DISPLAY_NAMES.besichtigung },
  { key: 'stadtgebiet', type: 'input', displayName: INPUT_DISPLAY_NAMES.stadtgebiet },
  { key: 'lage', type: 'input', displayName: INPUT_DISPLAY_NAMES.lage },
  { key: 'schwierigkeit', type: 'input', displayName: INPUT_DISPLAY_NAMES.schwierigkeit },
  { key: 'zimmer', type: 'input', displayName: INPUT_DISPLAY_NAMES.zimmer },
  { key: 'stellplatzTyp', type: 'input', displayName: INPUT_DISPLAY_NAMES.stellplatzTyp },
  { key: 'inseratpreis', type: 'input', displayName: INPUT_DISPLAY_NAMES.inseratpreis },
  { key: 'wohnflaeche', type: 'input', displayName: INPUT_DISPLAY_NAMES.wohnflaeche },
  { key: 'inseratpreisProQm', type: 'kpi', displayName: KPI_DISPLAY_NAMES.inseratpreisProQm },
  { key: 'angebotspreis', type: 'input', displayName: INPUT_DISPLAY_NAMES.angebotspreis },
  { key: 'angebotspreisProQm', type: 'kpi', displayName: KPI_DISPLAY_NAMES.angebotspreisProQm },
  { key: 'preisreduktion', type: 'kpi', displayName: KPI_DISPLAY_NAMES.preisreduktion },
  { key: 'kaltmieteProQm', type: 'input', displayName: INPUT_DISPLAY_NAMES.kaltmieteProQm },
  { key: 'stellplatzMiete', type: 'input', displayName: INPUT_DISPLAY_NAMES.stellplatzMiete },
  { key: 'bruttomietrendite', type: 'kpi', displayName: KPI_DISPLAY_NAMES.bruttomietrendite },
  { key: 'eigenkapital', type: 'kpi', displayName: KPI_DISPLAY_NAMES.eigenkapital },
  { key: 'monatlicheRate', type: 'kpi', displayName: KPI_DISPLAY_NAMES.monatlicheRate },
  { key: 'jahresmiete', type: 'kpi', displayName: KPI_DISPLAY_NAMES.jahresmiete },
  { key: 'positiveMerkmale', type: 'input', displayName: 'Positive Merkmale' },
  { key: 'negativeMerkmale', type: 'input', displayName: 'Negative Merkmale' }
];

export const CSV_EXPORT_HEADERS = [
  'id',
  'name',
  'isFavorite',
  ...Object.keys(DEFAULT_INPUTS).filter(key => !key.startsWith('loi') && key !== 'propertyName')
];

export const PROPERTY_STORAGE_KEY = APP_CONFIG.STORAGE.LOCAL_STORAGE_PREFIX + 'portfolio';

// Sanierungsrechner Constants
export const COST_REFERENCES: CostReferences = {
  bad: { basis: 7000, mittel: 12000, premium: 18000 },
  kueche: { basis: 3000, mittel: 6000, premium: 15000 },
  heizkoerper: { basis: 350, mittel: 550, premium: 900 },
  heizung_komplett: { basis: 7000, mittel: 9000, premium: 12000 },
  wasserleitungen: { basis: 3000, mittel: 4000, premium: 5000 },
  tueren: { basis: 400, mittel: 650, premium: 1000 },
  fenster: { basis: 700, mittel: 1100, premium: 1600 },
  rollos: { basis: 250, mittel: 450, premium: 700 },
  boden: { basis: 40, mittel: 75, premium: 130 },
  fliesenboden: { basis: 60, mittel: 80, premium: 100 },
  elektrik: { basis: 90, mittel: 120, premium: 160 },
  malen: { basis: 25, mittel: 35, premium: 55 },
  fassade: { basis: 120, mittel: 170, premium: 250 },
  dach: { basis: 180, mittel: 260, premium: 350 },
};

export const STADTGEBIETE = [
  "Zentrum",
  "Westenviertel",
  "Königswiesen",
  "Kasernenviertel",
  "Stadt am Hof",
  "Reinhausen",
  "Kumpfmühl",
  "Galgenberg",
  "Zegetsdorf",
  "Osten",
  "Andere"
];

export const LAGE_OPTIONS = ["A", "A/B", "B", "C", "D"];
export const STELLPLATZ_OPTIONS = ["Nein", "TG", "St.Platz"];
export const SCHWIERIGKEIT_OPTIONS = [1, 2, 3, 4, 5];